import React, { useEffect, useState, memo } from 'react';
import { ClockIcon } from 'lucide-react';
export const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(14);
  useEffect(() => {
    // Simulate sales happening occasionally
    const interval = setInterval(() => {
      setCopiesLeft(prev => {
        if (prev <= 3) return 3; // Don't go below 3
        return Math.random() > 0.7 ? prev - 1 : prev;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);
  return <div className="inline-flex items-center gap-1.5 sm:gap-2 bg-rose-100 text-rose-800 px-3 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium border border-rose-200 shadow-sm animate-pulse-soft max-w-full" data-id="element-16">
      <ClockIcon className="w-3 h-3 sm:w-4 sm:h-4 flex-shrink-0" data-id="element-17" />
      <span className="truncate" data-id="element-18">Solo {copiesLeft} copias disponibles</span>
    </div>;
});